<template>
  <div>
    <div class="flex justify-between space-x-2 py-2">
      <div class="flex items-center justify-center">
        <div
          class="bg-primary relative flex h-10 w-10 items-center justify-center rounded text-white"
          :style="
            orderItem.product?.color
              ? { backgroundColor: orderItem.product.color }
              : {}
          "
        >
          {{ shortString }}
        </div>
      </div>
      <div
        class="flex flex-1 flex-col items-start justify-around"
      >
        <div class="text-sm">
          {{ orderItem.product?.name || "Custom" }}
        </div>

        <div
          v-if="orderItem.note"
          class="text-background-fg/70 line-clamp-1 text-xs"
        >
          {{ orderItem.note }}
        </div>
      </div>
      <div class="flex w-24 items-center justify-end">
        <p
          class="line-clamp-1 text-right text-sm font-semibold"
        >
          {{
            formatToMerchantCurrencyString(orderItem.price)
          }}
        </p>
      </div>
    </div>
    <ul
      v-if="orderItem.productModifierLabels?.length"
      class="border-1 rounded p-2"
      :style="{
        borderColor: orderItem.product?.color ?? 'black',
      }"
    >
      <li
        v-for="modifier in orderItem.productModifierLabels"
        :key="modifier"
        class="text-background-fg/70 text-xs"
      >
        {{ modifier }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { OrderDetailOrderItem } from "@/services/orders/retrieveOrder"

const props = defineProps<{
  orderItem: OrderDetailOrderItem
}>()

const { formatToMerchantCurrencyString } = useCurrency()

const shortString = computed(() => {
  return props.orderItem.product
    ? buildShortString(props.orderItem.product.name)
    : "-"
})
</script>
